<div mat-dialog-title>
    <mat-toolbar class="dark:bg-contrast-black">
        <mat-toolbar-row
            class="dark:text-contrast-yellow"
            [ngClass]="{ 'flex-justify-between': !env.USE_TAILWIND, 'flex justify-between': env.USE_TAILWIND }">
            <h1>
                {{ title ?? title | translate }}
            </h1>
            <button
                class="flex flex-row items-center justify-center"
                (click)="closeDialog.emit()"
                mat-icon-button
                matDialogClose
                aria-label="{{ 'LOCAL_BTN_CLOSE' | translate }}"
                title="{{ 'LOCAL_BTN_CLOSE' | translate }}">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<mat-dialog-content>
    <ng-content></ng-content>
</mat-dialog-content>
<mat-dialog-actions>
    <div [ngClass]="{ 'full-width': !env.USE_TAILWIND, 'w-full': env.USE_TAILWIND }">
        <ng-content select="[dialog-actions]"></ng-content>
    </div>
</mat-dialog-actions>
